import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-20 d-sm-flex align-items-center justify-content-between letter-spacing" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-5 mb-sm-0 fw-bold" }, "Company Research", -1)
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-items-center justify-content-between"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-medium text-black-emphasis mb-0" }, "Research Feedback", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "p-5 p-sm-10 p-md-15" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon flaticon-like fs-18 lh-1 position-relative top-2 me-3" }),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon flaticon-dislike fs-18 lh-1 position-relative top-2" })
], -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanyDetails = _resolveComponent("CompanyDetails")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("nav", null, [
        (_ctx.canAccessFeature('companyFeedback'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_CompanyDetails)
  ], 64))
}